import React, { useState, useEffect } from "react";
import { clusterApiUrl, Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
import { useWallet } from "@solana/wallet-adapter-react";

function UserSolanaBalance() {
    const wallet = useWallet();
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (wallet.connected && wallet.publicKey) {
            fetchBalance();
        }
    }, [wallet.connected, wallet.publicKey]);

    const fetchBalance = async () => {
        try {
            setLoading(true);
            const connection = new Connection(process.env.REACT_APP_RPC_ENDPOINT, "confirmed");
            const balanceLamports = await connection.getBalance(new PublicKey(wallet.publicKey));
            const balanceSol = balanceLamports / LAMPORTS_PER_SOL; // Convert lamports to SOL
            setBalance(balanceSol);
        } catch (error) {
            console.error("Error fetching balance:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {wallet.connected ? (
                <>
                    {loading ? (
                        <p>Loading balance...</p>
                    ) : (
                        <p>SOL: {balance !== null ? `${balance} SOL` : "Unable to fetch balance"}</p>
                    )}
                </>
            ) : (
                <p>No bal.</p>
            )}
        </div>
    );
}

export default UserSolanaBalance;
